<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Past Recruiters</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Past Recruiters</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <table class="table table-bordered" width="100%" cellspacing="2" cellpadding="2">
          <tbody>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/acadamy.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/adobe.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/amazon.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/analytics.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/ashok.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/benz.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/bosch.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/brightstone.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/btwise.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/capg.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/capgemini.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/cumins.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/cyrange.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/erson.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/excellon.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/globallogic.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/zenstar.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/godrej.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/h.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/hirect.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/IBM.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/videocon.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/infinity.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/infocept.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/novatech.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/ntt.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/persistance.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/phenix.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/samsung.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/smartdata.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/sokrati.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/syntel.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/tech.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/tatatech.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/tcs.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/think&amp;learn.webp" alt="GHRCACS, PUNE"></td>
            </tr>
            <tr>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/transril.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/triveni.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/wipro.webp" alt="GHRCACS, PUNE"></td>
              <td width="10%" align="center"><img src="{{baseUrl}}/recruiters/icici_bank.webp" alt="GHRCACS, PUNE"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
